import { SnowplowHelper } from '../helpers/snowplow_helper';

class ProviderWrapper {
  loaded: boolean;

  log: any;

  provider: any;

  constructor({ log, provider }: any) {
    this.loaded = false;
    this.log = log;
    this.provider = provider;
  }

  isApprovedProvider(): boolean {
    return this.provider.constructor.isApprovedProvider;
  }

  load(snowplowHelper: SnowplowHelper | null = null) {
    if (!this.loaded) {
      this.delegate('load', snowplowHelper ? [snowplowHelper] : []);
      this.loaded = true;
    }
  }

  identify(...args: any[]) {
    this.delegate('identify', args);
  }

  group(...args: any[]) {
    this.delegate('group', args);
  }

  page(...args: any[]) {
    this.delegate('page', args);
  }

  track(...args: any[]) {
    this.delegate('track', args);
  }

  delegate(method: any, args: any[] = []) {
    this.log(`${method} ${this.providerName()}`, ...args);
    this.provider[method](...args);
  }

  providerName() {
    return this.provider.constructor.providerName;
  }
}

export default ProviderWrapper;
